import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    editTemplate: string;
    delete: string;
    loadingTemplates: string;
    templateDeleted: string;
    disableEdit: string;
    disableEditDeleted: string;
    disableDelete: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Label for editing template */
            editTemplate: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "WatermarkTemplateListItem.editTemplate?c=11wy46t4rgp3y", defaultMessage: "Edit Template" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for deleting template */
            delete: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "WatermarkTemplateListItem.delete?c=7nzkz7owpk0x", defaultMessage: "Delete" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Loading state message */
            loadingTemplates: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "WatermarkTemplateListItem.loadingTemplates?c=a2fh5d1dak02", defaultMessage: "Loading Watermark Templates" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Message when template is deleted */
            templateDeleted: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "WatermarkTemplateListItem.templateDeleted?c=36qnqpht85uky", defaultMessage: "Template deleted by account admin" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Message when editing is disabled due to plan */
            disableEdit: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "WatermarkTemplateListItem.disableEdit?c=31ccjuz3d2xqy", defaultMessage: "Your current plan doesn''t allow editing this template" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Message when editing deleted template is disabled */
            disableEditDeleted: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "WatermarkTemplateListItem.disableEditDeleted?c=27cptsd48b6kv", defaultMessage: "You can''t edit deleted templates" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Message when deleting is disabled due to template being in use */
            disableDelete: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "WatermarkTemplateListItem.disableDelete?c=20lovgne23fbx", defaultMessage: "This template cannot be deleted because it is currently in use." }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
